import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WebsocketService } from '@shared/services/websocket.service';
import { InvoiceProcessingService } from '@shared/services/invoice-processing.service';
import { filter, map, merge, of, switchMap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AsyncPipe } from '@angular/common';
import { WebsocketEvent } from '../../../../../../types/websocket';
import { CargoLoadingState } from '../../../../store/cargo-loading.state';
import { InvoiceProcessStatus } from '../../../../../../types/invoice-process';
import { CommonStateService } from '../../../../services/common-state.service';

@Component({
  selector: 'app-active-processes',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './active-processes.component.html',
  styleUrl: './active-processes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveProcessesComponent {
  cargoId$ = this.store.select(CargoLoadingState.getSelectedCargo).pipe(
    map(cargo => cargo?.id),
    filter(Boolean),
  );

  processes$ = this.cargoId$.pipe(
    switchMap(cargoId =>
      merge(
        of(null),
        this.commonStateService.refreshActiveProcesses$,
        this.ws.cargoEvents$.pipe(
          filter(
            ws => ws.event === WebsocketEvent.INVOICE_PROCESSING_CHANGE_STATUS,
          ),
        ),
      ).pipe(switchMap(() => this.ips.getByCargoId(cargoId))),
    ),
  );

  activeProcesses$ = this.processes$.pipe(
    map(processes =>
      processes.filter(p => p.status === InvoiceProcessStatus.PROCESSING),
    ),
  );

  constructor(
    private readonly store: Store,
    private readonly ws: WebsocketService,
    private readonly ips: InvoiceProcessingService,
    private readonly commonStateService: CommonStateService,
  ) {}
}
